import { Box } from "@material-ui/core";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import KeyboardBackspaceSharpIcon from "@material-ui/icons/KeyboardBackspaceSharp";
import React, { memo } from "react";
import { useHistory } from "react-router-dom";
import { useStyles } from "./style";

const FormPageHeader = (props) => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <>
      <Box className={classes.pageHeaderWrap}>
        <Box className={classes.formHeader}>
          <Box className={classes.backIcon} onClick={() => history.goBack()}>
            <KeyboardBackspaceSharpIcon />
          </Box>
          <h1 className={classes.header}>
            {props.customTitle
              ? `${props.title} - ${props.customTitle.substring(0, 18)}...`
              : `${props.title}`}
          </h1>
        </Box>
        <Box>
          <Breadcrumbs aria-label="breadcrumb">
            <p color="inherit" href="/">
              Home
            </p>
            <p color="textPrimary" href={props.parentLink}>
              {props.pageName}
            </p>
            <p color="textPrimary" href={props.childLink}>
              {props.mode}
            </p>
          </Breadcrumbs>
        </Box>
      </Box>
    </>
  );
};

export default memo(FormPageHeader);
